import React from 'react';
import { HeartIcon } from 'lucide-react';
import { checkoutUrl } from '../data/pricing';
interface CtaButtonProps {
  label: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  /** 'checkout' va directo al pago; 'offer' lleva a la primera oferta de la página */
  target?: 'checkout' | 'offer';
}
export function CtaButton({
  label,
  size = 'md',
  fullWidth = true,
  target = 'checkout'
}: CtaButtonProps) {
  const isOffer = target === 'offer';
  const sizing = size === 'lg' ? 'px-6 py-4 text-sm sm:px-8 sm:py-5 sm:text-lg' : 'px-5 py-3.5 text-sm sm:px-7 sm:py-4 sm:text-base';
  return <a href={isOffer ? '#oferta' : checkoutUrl} target={isOffer ? undefined : '_blank'} rel={isOffer ? undefined : 'noopener noreferrer'} className={['group inline-flex items-center justify-center gap-2.5 rounded-full bg-gold-500 font-display font-800 uppercase tracking-wide text-teal-900 sm:gap-3', 'shadow-lift ring-1 ring-gold-600/40', 'transition-[transform,background-color,box-shadow] duration-150 ease-out', 'hover:bg-gold-400 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98]', 'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/60', sizing, fullWidth ? 'w-full sm:w-auto' : ''].join(' ')} data-id="element-80" data-mp="109buepegr94p">
      <HeartIcon className="h-4 w-4 shrink-0 fill-teal-900/20 transition-transform duration-150 ease-out group-hover:scale-110 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-81" data-mp="3jy8l1ya48cgk" />
      <span className="text-center leading-tight" data-id="element-82" data-mp="3sw2duz8o8nyz">{label}</span>
    </a>;
}